import React from 'react';

function Index() {
    return (
        <div className={"flex flex-col md:flex-row justify-center content-center"}>
            <div className="md:w-1/2 flex flex-col justify-center">
                <p className="mb-2">どうも陽射矢　夜叉非（ひさや　やさひ）です！</p>
                <p className="mb-2">２人組み（ヒユキとヤジ）で漫画書いてます！</p>
                <p className="mb-2">学生なので（いずれ学生でなくなっても）更新が遅いかもしれませんが何卒よろしくお願いいたします:D</p>
                <p className="mb-8">楽しんでね～☆</p>
                <p className="mb-2">ラジオもたまに更新してます…↓↓↓</p>
                <p className="mb-2 text-blue-500 hover:text-blue-600">
                    <a href='https://www.youtube.com/playlist?list=PLCqChtR7D8nVQVWdzFa9xzF5PhUpWyVUC'>
                        ヒサヤヤサヒのAll Night Fever (YouTube)
                    </a>
                </p>
            </div>

            <div className="md:w-1/2 bg-white rounded-3xl md:bg-transparent">
                <img src={"/illust/us.png"} alt={'陽射矢夜叉非イメージ画像'} />
            </div>
        </div>
    );
}

export default Index;